"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var YoutubeFill = {
    name: 'youtube',
    theme: 'fill',
    nameWithTheme: 'youtube-fill',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M941.3 296.1c-10.3-38.6-40.7-69-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7C123.3 227 93 257.4 82.7 296 64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z'
            },
            children: []
        }
    ]
};
exports.default = YoutubeFill;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.0@@ant-design/icons/lib/fill/YoutubeFill.js
// module id = 685
// module chunks = 0 1